import { defineMessages } from 'react-intl';

/**
 * Internationalized messages for use on general components.
 */
export default defineMessages({
  language: {
    id: 'localeSelect.language',
    defaultMessage: 'Language',
  },
  selectOrganisation: {
    id: 'formInputs.organisation.select',
    defaultMessage: 'Select organization',
  },
  country: {
    id: 'formInputs.country.select',
    defaultMessage: 'Country',
  },
  definition: {
    id: 'foooter.definition',
    defaultMessage:
      'Tasking Manager is a platform where individuals can team up for mapping in OpenStreetMap',
  },
  credits: {
    id: 'footer.credits',
    defaultMessage:
      'Free and Open Source Software brought to you by the Humanitarian OpenStreetMap Team.',
  },
  learn: {
    id: 'footer.learn',
    defaultMessage: 'Learn more about OpenStreetMap.',
  },
  privacyPolicy: {
    id: 'footer.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  mappingLevelALL: {
    id: 'mapping.level.all',
    defaultMessage: 'All levels',
  },
  mappingLevelADVANCED: {
    id: 'mapping.level.advanced',
    defaultMessage: 'Advanced mapper',
  },
  mappingLevelINTERMEDIATE: {
    id: 'mapping.level.intermediate',
    defaultMessage: 'Intermediate mapper',
  },
  mappingLevelBEGINNER: {
    id: 'mapping.level.beginner',
    defaultMessage: 'Beginner mapper',
  },
  roads: {
    id: 'project.typesOfMapping.roads',
    defaultMessage: 'Roads',
  },
  buildings: {
    id: 'project.typesOfMapping.buildings',
    defaultMessage: 'Buildings',
  },
  landUse: {
    id: 'project.typesOfMapping.landUse',
    defaultMessage: 'Land use',
  },
  waterways: {
    id: 'project.typesOfMapping.waterways',
    defaultMessage: 'Waterways',
  },
  other: {
    id: 'project.typesOfMapping.other',
    defaultMessage: 'Other',
  },
  pointsOfInterest: {
    id: 'project.typesOfMapping.pointsOfInterest',
    defaultMessage: 'Points of interest',
  },
});
